const TRACKING_INFORMATION = {
  widgetOpenedByClick: {
    action: 'widget-opened',
    category: 'widget',
    label: 'by-click',
  },
  widgetOpenedByHash: {
    action: 'widget-opened',
    category: 'widget',
    label: 'by-urlfragment',
  },
  closeWidget: {
    action: 'widget-closed',
    category: 'widget',
    label: 'by-click',
  },
  inlineLinkClick: {
    action: 'inline-link-clicked',
    category: 'navigation',
  },
  orderLinkClick: {
    action: 'orderpicker-link-clicked',
    category: 'navigation',
  },
  buttonLinkClicked: {
    action: 'button-link-clicked',
    category: 'navigation',
  },
  loginSuccess: {
    action: 'login-success',
    label: 'success',
    category: 'addin-login',
  },
  loginFailure: {
    action: 'login-failure',
    label: 'failure',
    category: 'addin-login',
  },
  loginError: {
    action: 'login-error',
    label: 'error',
    category: 'addin-login',
  },
  messageSent: {
    action: 'message-sent',
    category: 'message',
  },
  addInLoginTriggered: {
    action: 'login-displayed',
    category: 'addin-login',
  },
  addInOrderpickerTriggered: {
    action: 'order-picker-displayed',
    category: 'addin-orderpicker',
  },
  addInOrderpickerClosed: {
    action: 'order-picker-closed',
    category: 'addin-orderpicker',
  },
  selfServiceReturnClicked: {
    action: 'order-return-clicked',
    category: 'addin-orderpicker',
    label: 'self-service',
  },
  selfServiceCancelClicked: {
    action: 'order-cancel-clicked',
    category: 'addin-orderpicker',
    label: 'self-service',
  },
  selfServiceUnvailableClicked: {
    action: 'unavailable-clicked',
    category: 'addin-orderpicker',
    label: 'self-service',
  },
  addInProductInfoTriggered: {
    action: 'productinfo-picker-displayed',
    category: 'addin-productinfo',
  },
  addInProductInfoClosed: {
    action: 'productinfo-picker-closed',
    category: 'addin-productinfo',
  },
  addInLoginClosed: {
    action: 'login-closed',
    category: 'addin-login',
  },
  userlikeDisplayed: {
    action: 'userlike-displayed',
    category: 'addin-userlike',
  },
  userlikeInitiated: {
    action: 'userlike-init',
    category: 'addin-userlike',
  },
  userlikeClosed: {
    action: 'userlike-closed',
    category: 'addin-userlike',
  },
}

export default TRACKING_INFORMATION
